import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardCreateComponent } from './giftcard-create.component';
import { PosStepperModule } from 'src/app/shared/pos-stepper/pos-stepper.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CustomerStepModule } from '../../sales/customer-step/customer-step.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GiftcardCartStepModule } from './giftcard-cart-step/giftcard-cart-step.module';
import { GiftcardSaveStepModule } from './giftcard-save-step/giftcard-save-step.module';
import { InvoiceDetailsStepModule } from '../../invoices/invoice-stepper/invoice-details-step/invoice-details-step.module';
import { PayInvoiceStepModule } from '../../invoices/invoice-stepper/pay-invoice-step/pay-invoice-step.module';



@NgModule({
  declarations: [
    GiftcardCreateComponent
  ],
  imports: [
    CommonModule,
    PosStepperModule,
    CdkStepperModule,
    CustomerStepModule,
    ReactiveFormsModule,
    GiftcardCartStepModule,
    GiftcardSaveStepModule,
    InvoiceDetailsStepModule,
    PayInvoiceStepModule
  ],
  exports: [GiftcardCreateComponent]
})
export class GiftcardCreateModule { }
